import React, { useState } from "react";
import { Row, Col, Container, NavDropdown } from "react-bootstrap";
import styles from "./Header.module.css";
import logo from "../../assets/Logo.png";
import { Link, useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import services from "../../constant/services";
import { connect } from "react-redux";

const Header = ({ isAuth }) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  return (
    <>
      <div className={styles.ham}>
        <img
          src={logo}
          className={styles.logo}
          alt=""
          onClick={() => navigate("/")}
        />
        <GiHamburgerMenu size={36} color="#fff" onClick={() => setShow(true)} />
      </div>
      <div
        className={`${styles.overlay} ${show === true ? styles.active : ""}`}
      ></div>

      <Container
        className={`${styles.wrapper} ${show === true ? styles.active : ""}`}
      >
        <Row>
          <Col
            md={2}
            className="py-3 d-flex justify-content-md-start justify-content-center d-md-block d-none"
          >
            <img
              src={logo}
              className={styles.logo}
              alt=""
              onClick={() => navigate("/")}
            />
          </Col>
          <Col
            md={12}
            className="py-3 d-flex justify-content-md-end justify-content-between d-md-none d-block"
          >
            <img
              src={logo}
              className={styles.logo}
              alt=""
              onClick={() => navigate("/")}
            />
            <span className="d-block" onClick={() => setShow(false)}>
              <AiOutlineClose color="#fff" size={36} />{" "}
            </span>
          </Col>
          <Col
            md={10}
            className="py-3 d-flex justify-content-end align-items-center flex-md-row flex-column"
          >
            <Link to="/about" className={styles.link}>
              About
            </Link>

            <NavDropdown
              title="Service"
              id="basic-nav-dropdown"
              className={styles.link}
            >
              {services.map((item, index) => (
                <NavDropdown.Item
                  key={index}
                  as={Link}
                  to={`/services/${item.link}`}
                >
                  {item.name}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
            {/* <NavDropdown
              title="Capabilities"
              id="dd_capabilities"
              className={styles.link}
            >
              {services.slice(0, 3).map((item, index) => (
                <NavDropdown.Item
                  key={index}
                  as={Link}
                  to={`/services/${item.link}#capabilities`}
                >
                  {item.name}
                </NavDropdown.Item>
              ))}
            </NavDropdown> */}
            {/* <NavDropdown
              title="Pricing"
              id="dd_pricing"
              className={styles.link}
            >
              {services.slice(0, 3).map((item, index) => (
                <NavDropdown.Item
                  key={index}
                  as={Link}
                  to={`/services/${item.link}#pricing`}
                >
                  {item.name}
                </NavDropdown.Item>
              ))}
            </NavDropdown> */}

            {/* <Link to="/shop" className={styles.link}>
              Shop
            </Link> */}
            <Link to="/contact" className={styles.link}>
              Contact Us
            </Link>
            {isAuth === true ? (
              <Link to="/dashboard" className={styles.link}>
                Dashboard
              </Link>
            ) : (
              <></>
            )}

            {/* <div className="d-flex">
            <a
              href="https://docs.google.com/forms/d/1266EQ6fE-x6BLXgE3hWxm87aGPjsz-std5gNGomEzMU/edit?usp=drivesdk"
              target={"_blank"}
              rel="noopener noreferrer"
              className="btn_primary"
            >
              Order
            </a>
          </div> */}
          </Col>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, null)(Header);
